export const PORTRAIT_MOBILE_PANEL_INITIAL_HEIGHT = 338;
const LOWEST_POINT = '96px';
export const SNAP_POINTS_PORTRAIT = [LOWEST_POINT, `${PORTRAIT_MOBILE_PANEL_INITIAL_HEIGHT}px`, 1];
export const SNAP_POINTS_LANDSCAPE = [LOWEST_POINT, 1];
export const LANDSCAPE_ANGLES = [90, 270];
export const HANDLE_PADDING = 16;
